import { useGlobalStore } from '../store'

import bindActions from '../store/bindActions'
import { CoreReducer, CoreSliceType } from '../store/core'
import { Fn } from 'depoto-core'
import { setSelectedDate } from '../store/core/actions'

const { actions } = CoreReducer

type CoreHookReturnType = CoreSliceType & {
  setCore: Fn
  setCarriers: Fn
  setCheckouts: Fn
  setSelectedCarrierIds: Fn
  setSelectedCheckoutId: Fn
  setSelectedCountry: Fn
  setSelectedDepotId: Fn
  setCountries: Fn
  setDepots: Fn
  setCurrencies: Fn
  setCompany: Fn
  setChildCompanies: Fn
  setSelectedChildCompany: Fn
  setCurrentOrder: Fn
  setOrdersHistory: Fn
  setIsStrictDepotFilter: Fn
  setAutoProcessStatusChange: Fn
  setOrderUpdates: Fn
  setPackageUpdates: Fn
  setGroupHistory: Fn
  setGroupFilterName: Fn
  setTags: Fn
  setSelectedTagId: Fn
  setSearchString: Fn
  setSearchType: Fn
  setIsFetching: Fn
  setSelectedDate: Fn
}
export const useCore = (): CoreHookReturnType => {
  const { state, dispatch } = useGlobalStore()
  const { core } = state
  const {
    setCore,
    setCarriers,
    setCheckouts,
    setSelectedCarrierIds,
    setSelectedCheckoutId,
    setSelectedCountry,
    setSelectedDepotId,
    setCountries,
    setDepots,
    setCurrencies,
    setCompany,
    setChildCompanies,
    setSelectedChildCompany,
    setCurrentOrder,
    setOrdersHistory,
    setIsStrictDepotFilter,
    setAutoProcessStatusChange,
    setOrderUpdates,
    setPackageUpdates,
    setGroupHistory,
    setGroupFilterName,
    setTags,
    setSelectedTagId,
    setSearchString,
    setSearchType,
    setIsFetching,
  } = actions
  const coreActions = bindActions(
    {
      setCore,
      setCarriers,
      setCheckouts,
      setSelectedCarrierIds,
      setSelectedCheckoutId,
      setSelectedCountry,
      setSelectedDepotId,
      setCountries,
      setDepots,
      setCurrencies,
      setCompany,
      setChildCompanies,
      setSelectedChildCompany,
      setCurrentOrder,
      setOrdersHistory,
      setIsStrictDepotFilter,
      setAutoProcessStatusChange,
      setOrderUpdates,
      setPackageUpdates,
      setGroupHistory,
      setGroupFilterName,
      setTags,
      setSelectedTagId,
      setSearchString,
      setSearchType,
      setSelectedDate,
      setIsFetching,
    },
    dispatch,
  )

  return { ...core, ...coreActions }
}
